/**
 * Fit the 1792×828 stage into the current viewport using a CSS scale
 * transform.
 */
import { REF_WIDTH, REF_HEIGHT } from '../config';

export class ResponsiveScaler {
  private readonly stage: HTMLElement;
  private onChange?: (scale: number) => void;
  private readonly handler = (): void => this.apply();

  constructor(stageId = 'stage') {
    const el = document.getElementById(stageId);
    if (!el) throw new Error(`ResponsiveScaler: #${stageId} not found`);
    this.stage = el;
  }

  attach(onChange?: (scale: number) => void): void {
    this.onChange = onChange;
    window.addEventListener('resize', this.handler);
    window.addEventListener('orientationchange', this.handler);
    this.apply();
  }

  detach(): void {
    window.removeEventListener('resize', this.handler);
    window.removeEventListener('orientationchange', this.handler);
  }

  private apply(): void {
    const w = window.innerWidth;
    const h = window.innerHeight;
    const scale = Math.min(w / REF_WIDTH, h / REF_HEIGHT);
    this.stage.style.transform = `scale(${scale})`;
    this.onChange?.(scale);
  }
}
